export default "__VITE_ASSET__f8b56047__"